import React, { useState } from "react";
import styles from "./OrderChecklist.module.css";
import { SearchInput, TextComponent } from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { SearchOutlined } from "@ant-design/icons";
import { BiArrowToRight } from "react-icons/bi";
import { Table } from "antd";
import {
  IoArrowDownCircleOutline,
  IoArrowUpCircleOutline,
} from "react-icons/io5";
import { ReactComponent as Checkboxes } from "../../../../assets/images/Checkboxes.svg";
import { ReactComponent as RightOrdericon } from "../../../../assets/images/rightOrdericon.svg";
import { ReactComponent as ArrowIconWhite } from "../../../../assets/images/ArrowIconWhite.svg";

const OrderChecklist = () => {
  const columns = [
    {
      title: "Item Name",
      dataIndex: "ItemName",
      key: "ItemName",
    },
    {
      title: "Quantity",
      key: "Quantity",
      dataIndex: "Quantity",
    },
    {
      title: "Prepared",
      key: "Prepared",
      dataIndex: "Prepared",
    },
  ];
  const stationColumns = [
    {
      title: "Station",
      dataIndex: "Station",
      key: "Station",
    },
    {
      title: "Task ID",
      key: "TaskID",
      dataIndex: "TaskID",
    },
    {
      title: "Status",
      key: "Status",
      dataIndex: "Status",
    },
  ];
  const stationData = [
    {
      Station: "Mixing",
      TaskID: "153456",
      Status: "Completed",
    },
    {
      Station: "Makeup",
      TaskID: "153456",
      Status: "Scheduled",
    },
    {
      Station: "Proof",
      TaskID: "153456",
      Status: "In Progress",
    },
    {
      Station: "Chill",
      TaskID: "153456",
      Status: "Scheduled",
    },
    {
      Station: "Packaging",
      TaskID: "153456",
      Status: "In Progress",
    },
  ];

  const data = [
    {
      ItemName: "Pie Crust Dough",
      Quantity: "25",
      Prepared: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
    },
  ];

  const orderData = [
    {
      name: "John Smith",
      status: "Completed",
    },
    {
      name: "Rodger Struck",
      status: "Scheduled",
    },
    {
      name: "Joshua Jones",
      status: "In Progress",
    },
    {
      name: "Daniel Hamilton",
      status: "Completed",
    },
    {
      name: "Frances Swann",
      status: "Scheduled",
    },
    {
      name: "Joshua Jones",
      status: "In Progress",
    },
    {
      name: "Joshua Jones",
      status: "In Progress",
    },
    {
      name: "Daniel Hamilton",
      status: "Completed",
    },
    {
      name: "Frances Swann",
      status: "Scheduled",
    },
    {
      name: "Joshua Jones",
      status: "In Progress",
    },
  ];

  const [expanded, setExpanded] = useState(false);
  const [selectedOrderIndex, setSelectedOrderIndex] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState(orderData[0]);
  const handleToggle = () => setExpanded(!expanded);

  const orderItems = {
    "John Smith": [
      {
        ItemName: "Pie Crust Dough",
        Quantity: "25",
        Prepared: (
          <div className={styles.checkboxContainer}>
            <Checkboxes />
          </div>
        ),
      },
    ],
    "Rodger Struck": [
      {
        ItemName: "Dinner Rolls",
        Quantity: "40",
        Prepared: (
          <div className={styles.checkboxContainer}>
            <Checkboxes />
          </div>
        ),
      },
    ],
    "Joshua Jones": [
      {
        ItemName: "Croissant Dough",
        Quantity: "12",
        Prepared: (
          <div className={styles.checkboxContainer}>
            <Checkboxes />
          </div>
        ),
      },
    ],
    "Daniel Hamilton": [
      {
        ItemName: "Baguette",
        Quantity: "60",
        Prepared: (
          <div className={styles.checkboxContainer}>
            <Checkboxes />
          </div>
        ),
      },
    ],
    "Frances Swann": [
      {
        ItemName: "Sourdough",
        Quantity: "18",
        Prepared: (
          <div className={styles.checkboxContainer}>
            <Checkboxes />
          </div>
        ),
      },
    ],
  };

  return (
    <div>
      <HeaderComponent
        heading={"Orders Checklist"}
        headingStyle={styles.Heading}
        showBackIcon={true}
        showSearch={true}
      />

      <div className={styles.mainCont}>
        <div className={styles.leftCont}>
          {orderData.map((item, index) => (
            //                         <div
            //                             key={index}
            //                             className={styles.leftContBlock}
            //                          onClick={() => {
            //     setSelectedOrder(item);
            //     setSelectedOrderIndex(index);
            // }}
            //                             style={{ cursor: "pointer" }}
            //                         >
            <div
              key={index}
              className={`${styles.leftContBlock} ${
                selectedOrderIndex === index ? styles.activeBlock : ""
              }`}
              onClick={() => {
                setSelectedOrder(item);
                setSelectedOrderIndex(index);
              }}
              style={{ cursor: "pointer" }}
            >
              <div>
                <TextComponent
                  className={`${styles.label} ${
                    selectedOrderIndex === index ? styles.activeBlock : ""
                  }`}
                  text={item.name}
                />
              </div>

              <div className={styles.leftStatus}>
                <span>
                  <TextComponent
                    className={`${styles.Heading} ${
                      selectedOrderIndex === index ? styles.activeBlock : ""
                    }`}
                    text={"Order Status: "}
                  />
                </span>
                <TextComponent
                  className={`${styles.label} ${
                    selectedOrderIndex === index ? styles.activeBlock : ""
                  }`}
                  text={item.status}
                />
                {selectedOrderIndex === index ? (
                  <span>
                    <ArrowIconWhite />
                  </span>
                ) : (
                  <span>
                    <RightOrdericon />
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

           <div className={styles.rightCont}>
                    {selectedOrder ? (
                        <>
                            <div className={styles.rightCont1}>
                                <div onClick={handleToggle} style={{ float: "right" }}>
                                    {expanded ? (
                                        <IoArrowUpCircleOutline size={26} cursor={"pointer"} color="var(--primary-color)" />
                                    ) : (
                                        <IoArrowDownCircleOutline size={26} cursor={"pointer"} color="var(--primary-color)" />
                                    )}
                                </div>

                                <div style={{ width: "100%" }}>
                                    <Table
                                        scroll={{ x: true }}
                                        columns={columns}
                                        dataSource={orderItems[selectedOrder.name] || []}
                                        pagination={false}
                                        rowKey="ItemName"
                                    />
                                </div>
                            </div>

                            {expanded && (
                                <div>
                                    <Table
                                        scroll={{ x: true }}
                                        columns={stationColumns}
                                        dataSource={stationData}
                                        pagination={false}
                                        rowKey="Station"
                                    />
                                </div>
                            )}

                            <div className={styles.TableDiv}>
                                <div style={{ float: "right" }}>

                                    <IoArrowDownCircleOutline size={26} cursor={"pointer"} color="var(--primary-color)" />

                                </div>
                                <Table
                                    scroll={{ x: true }}
                                    columns={columns}
                                    dataSource={orderItems[selectedOrder.name] || [0]}
                                    pagination={false}
                                    rowKey="ItemName"
                                />
                            </div>

                            <div className={styles.TableDiv}>
                                <div style={{ float: "right" }}>

                                    <IoArrowDownCircleOutline size={26} cursor={"pointer"} color="var(--primary-color)" />

                                </div>
                                <Table
                                    scroll={{ x: true }}
                                    columns={columns}
                                    dataSource={orderItems[selectedOrder.name] || [0]}
                                    pagination={false}
                                    rowKey="ItemName"
                                />
                            </div>
                        </>
                    ) : (
                        <div style={{ padding: 20 }}>
                            <TextComponent text="Please select an order from the left." />
                        </div>
                    )}
                </div>
      </div>
    </div>
  );
};

export default OrderChecklist;
